$("#burger-container, #burger-container .menu-toggle").on("click", function (e) {
  e.preventDefault();
  e.stopPropagation();

  var $menu = $(".mobile-menu-panel");
  var $toggle = $("#burger-container .menu-toggle");
  var isOpen = !$menu.hasClass("open");

  $("#burger-container").toggleClass("open", isOpen);
  $menu.toggleClass("open", isOpen);
  $toggle.attr("aria-expanded", isOpen ? "true" : "false");
  $toggle.attr("aria-label", isOpen ? "Zamknij menu" : "Otwórz menu");
  $("body").toggleClass("menu-open", isOpen);

  if (!isOpen) {
    resetMobileMenuDrawer($menu);
  }
});

function resetMobileMenuDrawer($menu) {
  $menu.find(".menu-drawer__group.is-open").removeClass("is-open");
  $menu.find(".menu-drawer__toggle").attr("aria-expanded", "false");
}

function closeMobileMenu() {
  var $menu = $(".mobile-menu-panel");

  $("#burger-container").removeClass("open");
  $menu.removeClass("open");
  $("#burger-container .menu-toggle").attr("aria-expanded", "false").attr("aria-label", "Otwórz menu");
  $("body").removeClass("menu-open");
  resetMobileMenuDrawer($menu);
}

function getVideoOpinionsEmbedData(url) {
  if (!url || url === "#") {
    return null;
  }

  var normalizedUrl = String(url).trim();
  var youtubeMatch = normalizedUrl.match(
    /(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
  );
  var shortsMatch = !youtubeMatch
    ? normalizedUrl.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]+)/)
    : null;
  var videoId = youtubeMatch ? youtubeMatch[1] : (shortsMatch ? shortsMatch[1] : null);

  if (videoId) {
    return {
      type: "iframe",
      src: "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0&playsinline=1"
    };
  }

  var vimeoMatch = normalizedUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);

  if (vimeoMatch) {
    return {
      type: "iframe",
      src: "https://player.vimeo.com/video/" + vimeoMatch[1] + "?autoplay=1"
    };
  }

  if (/\.(mp4|webm|ogg)(\?.*)?$/i.test(normalizedUrl)) {
    return {
      type: "video",
      src: normalizedUrl
    };
  }

  return {
    type: "iframe",
    src: normalizedUrl
  };
}

function clearVideoOpinionsModalEmbed() {
  $("#videoOpinionsModal .video-opinions-modal__embed").empty();
}

function showVideoOpinionsModal($modal) {
  var modalEl = $modal[0];

  if (!modalEl) {
    return;
  }

  if (window.bootstrap && window.bootstrap.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
    return;
  }

  $modal.addClass("show").css("display", "block").removeAttr("aria-hidden");
  $("body").addClass("modal-open");
}

function openVideoOpinionsModal(url) {
  var embedData = getVideoOpinionsEmbedData(url);
  var $modal = $("#videoOpinionsModal");
  var $embed;

  if (!embedData || !$modal.length) {
    return;
  }

  $embed = $modal.find(".video-opinions-modal__embed");
  clearVideoOpinionsModalEmbed();

  if (embedData.type === "video") {
    $embed.html(
      '<video class="video-opinions-modal__video" controls autoplay playsinline>' +
      '<source src="' + embedData.src + '">' +
      "</video>"
    );
  } else {
    $embed.html(
      '<iframe class="video-opinions-modal__iframe" src="' + embedData.src + '" ' +
      'title="Opinia wideo" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>'
    );
  }

  showVideoOpinionsModal($modal);
}

document.addEventListener("click", function (e) {
  var card = e.target.closest ? e.target.closest(".video-opinions-card") : null;

  if (!card) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  openVideoOpinionsModal(card.getAttribute("data-video-url"));
}, true);

$(document).on("hidden.bs.modal", "#videoOpinionsModal", clearVideoOpinionsModalEmbed);

$(document).on("click", ".mobile-menu-panel.open .menu-drawer__toggle", function (e) {
  if (!window.matchMedia("(max-width: 1399.98px)").matches) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var $item = $(this).closest(".menu-drawer__group--expandable");
  var shouldOpen = !$item.hasClass("is-open");

  $(".mobile-menu-panel.open .menu-drawer__group.is-open").not($item).each(function () {
    $(this).removeClass("is-open");
    $(this).find(".menu-drawer__toggle").attr("aria-expanded", "false");
  });

  $item.toggleClass("is-open", shouldOpen);
  $(this).attr("aria-expanded", shouldOpen ? "true" : "false");
});

$(document).on("click", function (e) {
  var $menu = $(".mobile-menu-panel");

  if (!$menu.hasClass("open")) {
    return;
  }

  if ($(e.target).closest("#burger-container, .mobile-menu-panel").length) {
    return;
  }

  closeMobileMenu();
});

$(document).on("click", ".mobile-menu-panel.open .menu-drawer__link, .mobile-menu-panel.open .nav-offer-panel__links a, .mobile-menu-panel.open .nav-delivery-panel__column a, .mobile-menu-panel.open .nav-offer-panel__button", function () {
  if (!window.matchMedia("(max-width: 1399.98px)").matches) {
    return;
  }

  closeMobileMenu();
});

$(document).on("keydown", function (e) {
  if (e.key !== "Escape" || !$(".mobile-menu-panel").hasClass("open")) {
    return;
  }

  closeMobileMenu();
});

function closeHeaderMegaMenus() {
  closeOfferMegaMenu();
  closeDeliveryMegaMenu();
}

function closeOfferMegaMenu() {
  var $offerMega = $("#offerMegaMenu");
  var $offerToggle = $("#dropdownMenuOffer");
  var $offerItem = $(".nav-item--offer-mega");

  $offerMega.removeClass("is-open");
  $offerToggle.attr("aria-expanded", "false");
  $offerItem.removeClass("is-open");
}

function closeDeliveryMegaMenu() {
  var $deliveryMega = $("#deliveryMegaMenu");
  var $deliveryToggle = $("#dropdownMenuDelivery");
  var $deliveryItem = $(".nav-item--delivery-mega");

  $deliveryMega.removeClass("is-open");
  $deliveryToggle.attr("aria-expanded", "false");
  $deliveryItem.removeClass("is-open");
}

function toggleOfferMegaMenu() {
  var $offerMega = $("#offerMegaMenu");
  var $offerToggle = $("#dropdownMenuOffer");
  var $offerItem = $(".nav-item--offer-mega");
  var willOpen = !$offerMega.hasClass("is-open");

  if (willOpen) {
    closeDeliveryMegaMenu();
    $offerMega.addClass("is-open");
    $offerToggle.attr("aria-expanded", "true");
    $offerItem.addClass("is-open");
  } else {
    closeOfferMegaMenu();
  }
}

function toggleDeliveryMegaMenu() {
  var $deliveryMega = $("#deliveryMegaMenu");
  var $deliveryToggle = $("#dropdownMenuDelivery");
  var $deliveryItem = $(".nav-item--delivery-mega");
  var willOpen = !$deliveryMega.hasClass("is-open");

  if (willOpen) {
    closeOfferMegaMenu();
    $deliveryMega.addClass("is-open");
    $deliveryToggle.attr("aria-expanded", "true");
    $deliveryItem.addClass("is-open");
  } else {
    closeDeliveryMegaMenu();
  }
}

function initHeaderMegaMenus() {
  var $offerToggle = $("#dropdownMenuOffer");
  var $offerMega = $("#offerMegaMenu");
  var $deliveryToggle = $("#dropdownMenuDelivery");
  var $deliveryMega = $("#deliveryMegaMenu");

  if ($offerToggle.length && $offerMega.length) {
    $offerToggle.on("click", function (event) {
      if (!window.matchMedia("(min-width: 1400px)").matches) {
        return;
      }

      event.preventDefault();
      toggleOfferMegaMenu();
    });

    $(document).on("click", "#offerMegaMenu .nav-offer-panel__links a, #offerMegaMenu .nav-offer-panel__button", function () {
      closeOfferMegaMenu();
    });
  }

  if ($deliveryToggle.length && $deliveryMega.length) {
    $deliveryToggle.on("click", function (event) {
      if (!window.matchMedia("(min-width: 1400px)").matches) {
        return;
      }

      event.preventDefault();
      toggleDeliveryMegaMenu();
    });

    $(document).on("click", "#deliveryMegaMenu .nav-delivery-panel__column a", function () {
      closeDeliveryMegaMenu();
    });
  }

  $(document).on("click", function (event) {
    if (!window.matchMedia("(min-width: 1400px)").matches) {
      return;
    }

    if ($(event.target).closest(".nav-item--offer-mega, #offerMegaMenu, .nav-item--delivery-mega, #deliveryMegaMenu").length) {
      return;
    }

    closeHeaderMegaMenus();
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      closeHeaderMegaMenus();
    }
  });
}

function syncHeaderDropdownMode() {
  if (window.matchMedia("(max-width: 1399.98px)").matches) {
    closeHeaderMegaMenus();
  }
}

$(document).ready(initHeaderMegaMenus);
$(document).ready(initPopupKonsultacje);
$(document).ready(syncHeaderDropdownMode);
$(window).on("resize", syncHeaderDropdownMode);

function openPopupKonsultacje() {
  var $popup = $("#popupKonsultacje");

  if (!$popup.length) {
    return;
  }

  $popup.addClass("is-open").attr("aria-hidden", "false");
  $("body").addClass("popup-konsultacje-open");
  $popup.find(".popup-konsultacje__close").trigger("focus");
}

function closePopupKonsultacje() {
  var $popup = $("#popupKonsultacje");

  if (!$popup.length) {
    return;
  }

  $popup.removeClass("is-open").attr("aria-hidden", "true");
  $("body").removeClass("popup-konsultacje-open");
}

function initPopupKonsultacje() {
  var $popup = $("#popupKonsultacje");

  if (!$popup.length) {
    return;
  }

  $popup.on("click", "[data-popup-konsultacje-close]", function () {
    closePopupKonsultacje();
  });

  $(document).on("click", "[data-popup-konsultacje-open]", function (event) {
    event.preventDefault();
    openPopupKonsultacje();
  });

  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && $popup.hasClass("is-open")) {
      closePopupKonsultacje();
    }
  });
}

function mobileFont() {
  $("span").each(function () {
    if ($(this).is("[style]") && $(window).width() < 776) {
      var fontSize = parseInt($(this).css("font-size")) / 1.65 + "px";
      $(this).css("font-size", fontSize);
    }
  });
}
window.onload = mobileFont();

function squareHeight() {
  var squareHeight = parseInt($(".square").css("width")) * 0.566 + "px";
  $(".square").css("height", squareHeight);
}
window.onload = squareHeight();

$(window).scroll(function () {
  //if I scroll more than 1000px...
  if ($(window).scrollTop() < 300) {
    $("body").addClass("with-after");
  } else {
    $("body").removeClass("with-after");
  }
});

new WOW().init();
$(document).ready(function () {
  $(".flexslider").flexslider({
    directionNav: false,
  });
  $(".flex-control-nav").addClass("container");
});
$(document).ready(function () {
  $(".my-slick").slick({
    autoplay: false,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
          centerMode: true,
          centerPadding: "60px",
        },
      },
    ],
  });
});

$(document).ready(function () {
  $(".choose-menu").slick({
    autoplay: false,
    slidesToShow: 3,
    centerPadding: "60px",
    slideCount: [
      {
        breakpoint: 3,
        settings: {
          centerMode: true,
        }
      }
    ],
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          variableWidth: true,
          centerMode: true,
          centerPadding: "60px",
        },
      },
    ],
  });
});

$(".show-all").click(function () {
  $(".more-cities").toggleClass("d-none");
  $(".more-cities").toggleClass("wow fadeInUp animated");
});

// Realna wysokość paska górnego i nawigacji → --upper-nav-height / --nav-height.
// Z tego liczy się padding body i pozycja panelu menu, więc pasek zawijający się
// na mobile do dwóch linii nie zostawia luki ani nie zasłania treści.
(function () {
  var root = document.documentElement;

  function syncHeaderHeights() {
    var upperNav = document.getElementById("upper-nav");
    var nav = document.querySelector("header > nav");

    root.style.setProperty("--upper-nav-height", (upperNav ? upperNav.offsetHeight : 0) + "px");

    if (nav) {
      root.style.setProperty("--nav-height", nav.offsetHeight + "px");
    }
  }

  var syncTimeout = null;
  function scheduleSync() {
    window.clearTimeout(syncTimeout);
    syncTimeout = window.setTimeout(syncHeaderHeights, 100);
  }

  $(document).ready(function () {
    syncHeaderHeights();

    if (typeof ResizeObserver === "function") {
      var observer = new ResizeObserver(syncHeaderHeights);
      var upperNav = document.getElementById("upper-nav");
      var nav = document.querySelector("header > nav");

      if (upperNav) {
        observer.observe(upperNav);
      }
      if (nav) {
        observer.observe(nav);
      }
    }
  });

  $(window).on("load", syncHeaderHeights);
  $(window).on("resize orientationchange", scheduleSync);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(syncHeaderHeights);
  }
})();

var prevScrollpos = window.pageYOffset;
window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  var headerHeight = parseInt($('.upper-nav').css('height'));
  if (prevScrollpos < currentScrollPos && currentScrollPos > 110) {
    document.querySelector("header").style.top = headerHeight * -1 + "px";
    $(".mobile-menu-panel").addClass("scroll-down");
  } else {
    document.querySelector("header").style.top = "0px";
    $(".mobile-menu-panel").removeClass("scroll-down");
  }
  prevScrollpos = currentScrollPos;
};

$(document).ready(function () {
  $("[data-our-diets]").each(function () {
    var $section = $(this);
    var $filters = $section.find(".our-diets__filter");
    var $sliderWraps = $section.find("[data-slider-wrap]");
    var resizeDebounce;

    function getSlidesToShowForWidth(width) {
      if (width < 576) {
        return 1;
      }
      if (width < 992) {
        return 2;
      }
      if (width < 1200) {
        return 3;
      }
      return 4;
    }

    function shouldInitSlider(cardsCount) {
      return cardsCount > getSlidesToShowForWidth($(window).width());
    }

    function initSlider($wrap, cardsCount) {
      var $slider = $wrap.find("[data-our-diets-slider]");
      var $controls = $wrap.find("[data-our-diets-controls]");
      var $dots = $wrap.find(".our-diets__dots");
      var $prevArrow = $wrap.find(".our-diets__arrow--prev");
      var $nextArrow = $wrap.find(".our-diets__arrow--next");

      if (!$slider.length || $slider.hasClass("slick-initialized")) {
        return;
      }

      $controls.removeClass("is-hidden");

      $slider.slick({
        autoplay: false,
        arrows: cardsCount > 4,
        dots: cardsCount > 4,
        customPaging: function () {
          return "<span></span>";
        },
        appendDots: $dots,
        prevArrow: $prevArrow,
        nextArrow: $nextArrow,
        infinite: cardsCount > 4,
        slidesToShow: Math.min(4, cardsCount || 1),
        slidesToScroll: 1,
        centerMode: cardsCount < 4,
        centerPadding: "0px",
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: Math.min(3, cardsCount || 1),
              arrows: cardsCount > 3,
              dots: cardsCount > 3,
              infinite: cardsCount > 3,
              centerMode: cardsCount < 3
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: Math.min(2, cardsCount || 1),
              arrows: cardsCount > 2,
              dots: cardsCount > 2,
              infinite: cardsCount > 2,
              centerMode: cardsCount < 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              arrows: cardsCount > 1,
              dots: cardsCount > 1,
              infinite: cardsCount > 1,
              centerMode: true
            }
          }
        ]
      });

    }

    function destroySlider($wrap) {
      var $slider = $wrap.find("[data-our-diets-slider]");
      var $controls = $wrap.find("[data-our-diets-controls]");
      var $dots = $wrap.find(".our-diets__dots");

      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $dots.empty();
      $controls.addClass("is-hidden");
    }

    function syncSliderState($wrap) {
      if ($wrap.is("[data-slider-static]")) {
        return;
      }

      var $slider = $wrap.find("[data-our-diets-slider]");
      var cardsCount = $slider.find(".our-diets-card").length;
      var sliderNeeded = shouldInitSlider(cardsCount);
      var isInitialized = $slider.hasClass("slick-initialized");

      if (sliderNeeded && !isInitialized) {
        initSlider($wrap, cardsCount);
        return;
      }

      if (!sliderNeeded && isInitialized) {
        destroySlider($wrap);
        return;
      }

      if (!sliderNeeded) {
        $wrap.find("[data-our-diets-controls]").addClass("is-hidden");
      }
    }

    function applyFilterByIndex(index) {
      var normalizedIndex = ((index % $filters.length) + $filters.length) % $filters.length;
      var $activeFilter = $filters.eq(normalizedIndex);
      var filterKey = $activeFilter.data("filter");
      var $activeWrap = $sliderWraps.filter('[data-slider-wrap="' + filterKey + '"]');

      $filters.removeClass("our-diets__filter--active").attr("aria-pressed", "false");
      $activeFilter.addClass("our-diets__filter--active").attr("aria-pressed", "true");

      $sliderWraps.removeClass("is-active");
      $activeWrap.addClass("is-active");
      syncSliderState($activeWrap);

      var $activeSlider = $activeWrap.find("[data-our-diets-slider]");
      if ($activeSlider.hasClass("slick-initialized")) {
        $activeSlider.slick("setPosition");
      }
    }

    var initialIndex = $filters.index($filters.filter(".our-diets__filter--active").first());
    applyFilterByIndex(initialIndex >= 0 ? initialIndex : 0);

    $filters.on("click", function () {
      applyFilterByIndex($filters.index(this));
    });

    $(window).on("resize", function () {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(function () {
        $sliderWraps.each(function () {
          var $wrap = $(this);

          if ($wrap.is("[data-slider-static]")) {
            return;
          }

          if ($wrap.hasClass("is-active") || $wrap.find("[data-our-diets-slider]").hasClass("slick-initialized")) {
            syncSliderState($wrap);
          }
        });

        var $activeWrap = $sliderWraps.filter(".is-active");
        var $activeSlider = $activeWrap.find("[data-our-diets-slider]");
        if ($activeSlider.hasClass("slick-initialized")) {
          $activeSlider.slick("setPosition");
        }
      }, 120);
    });
  });
});

$(document).ready(function () {
  $("[data-info-boxes]").each(function () {
    var $section = $(this);
    var $itemsWrap = $section.find(".info-boxes__items");
    var $items = $section.find(".info-boxes__item");
    var $ellipses = $section.find(".info-boxes__ellipse");
    var $previous = $section.find(".info-boxes__arrow--prev");
    var $next = $section.find(".info-boxes__arrow--next");

    function activateByEllipseId(ellipseId) {
      var $activeItem = $items.filter('[data-ellipse-id="' + ellipseId + '"]').first();
      var $activeEllipses = $ellipses.filter('[data-ellipse-id="' + ellipseId + '"]');

      if (!$activeItem.length || !$activeEllipses.length) {
        return;
      }

      $items.removeClass("is-active");
      $activeItem.addClass("is-active");

      $ellipses.removeClass("is-active").attr("aria-pressed", "false");
      $activeEllipses.addClass("is-active").attr("aria-pressed", "true");

      var $activeEllipsesWrap = $activeItem.find(".info-boxes__ellipses");
      var ellipsesWrap = $activeEllipsesWrap[0];
      var activeEllipse = $activeItem.find('.info-boxes__ellipse[data-ellipse-id="' + ellipseId + '"]')[0];

      if (activeEllipse && ellipsesWrap && ellipsesWrap.scrollWidth > ellipsesWrap.clientWidth + 1) {
        activeEllipse.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
      }
    }

    function shiftActive(direction) {
      var $visibleEllipses = $items.filter(".is-active").find(".info-boxes__ellipse");

      if ($visibleEllipses.length < 2) {
        return;
      }

      var activeIndex = $visibleEllipses.index($visibleEllipses.filter(".is-active"));
      var nextIndex = (activeIndex + direction + $visibleEllipses.length) % $visibleEllipses.length;

      activateByEllipseId($visibleEllipses.eq(nextIndex).data("ellipse-id"));
    }

    // Wyrównanie wysokości opinii — najdłuższa opinia wyznacza wysokość dla wszystkich,
    // żeby przy zmianie ambasadora nie przeskakiwały imię, tytuł i nawigacja.
    function syncDescriptionHeight() {
      var $descriptions = $items.find(".info-box-item__description");

      if ($descriptions.length < 2) {
        return;
      }

      $descriptions.css("min-height", "");
      $itemsWrap.addClass("is-measuring");

      var tallest = 0;
      $descriptions.each(function () {
        tallest = Math.max(tallest, this.getBoundingClientRect().height);
      });

      $itemsWrap.removeClass("is-measuring");

      if (tallest > 0) {
        $descriptions.css("min-height", Math.ceil(tallest) + "px");
      }
    }

    var initialEllipseId = $ellipses.filter(".is-active").first().data("ellipse-id");
    if (typeof initialEllipseId !== "undefined") {
      activateByEllipseId(initialEllipseId);
    }

    $ellipses.on("click", function () {
      activateByEllipseId($(this).data("ellipse-id"));
    });

    $previous.on("click", function () {
      shiftActive(-1);
    });

    $next.on("click", function () {
      shiftActive(1);
    });

    // Swipe palcem po zdjęciu lub treści opinii przełącza ambasadora.
    var swipeStartX = 0;
    var swipeStartY = 0;
    var isSwiping = false;
    var isHorizontal = false;
    var swipeThreshold = 45;

    function isInteractiveTarget(target) {
      return !!(target && target.closest && target.closest("a, button, input, textarea, select, .info-boxes__navigation"));
    }

    $itemsWrap.each(function () {
      var wrap = this;

      wrap.addEventListener(
        "touchstart",
        function (event) {
          if (event.touches.length !== 1 || isInteractiveTarget(event.target)) {
            isSwiping = false;
            return;
          }

          swipeStartX = event.touches[0].clientX;
          swipeStartY = event.touches[0].clientY;
          isSwiping = true;
          isHorizontal = false;
        },
        { passive: true }
      );

      wrap.addEventListener(
        "touchmove",
        function (event) {
          if (!isSwiping || event.touches.length !== 1) {
            return;
          }

          var deltaX = event.touches[0].clientX - swipeStartX;
          var deltaY = event.touches[0].clientY - swipeStartY;

          if (!isHorizontal) {
            if (Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) {
              return;
            }

            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              isSwiping = false;
              return;
            }

            isHorizontal = true;
          }

          // Blokada poziomego przewijania strony w trakcie gestu.
          if (event.cancelable) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      wrap.addEventListener("touchend", function (event) {
        if (!isSwiping || !isHorizontal) {
          isSwiping = false;
          return;
        }

        var deltaX = event.changedTouches[0].clientX - swipeStartX;

        isSwiping = false;
        isHorizontal = false;

        if (Math.abs(deltaX) < swipeThreshold) {
          return;
        }

        shiftActive(deltaX < 0 ? 1 : -1);
      });

      wrap.addEventListener("touchcancel", function () {
        isSwiping = false;
        isHorizontal = false;
      });
    });

    syncDescriptionHeight();
    $(window).on("load", syncDescriptionHeight);

    var resizeTimeout = null;
    $(window).on("resize orientationchange", function () {
      window.clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(syncDescriptionHeight, 150);
    });
  });
});

$(document).ready(function () {
  $("[data-info-timer]").each(function () {
    var $timer = $(this);
    var targetDate = new Date($timer.data("info-timer-date"));

    if (isNaN(targetDate.getTime())) {
      return;
    }

    function formatUnit(value) {
      return String(Math.max(0, value)).padStart(2, "0");
    }

    function updateTimer() {
      var remainingSeconds = Math.max(0, Math.floor((targetDate.getTime() - Date.now()) / 1000));
      var hours = Math.floor(remainingSeconds / 3600);
      var minutes = Math.floor((remainingSeconds % 3600) / 60);
      var seconds = remainingSeconds % 60;

      $timer.find("[data-info-timer-hours]").text(formatUnit(hours));
      $timer.find("[data-info-timer-minutes]").text(formatUnit(minutes));
      $timer.find("[data-info-timer-seconds]").text(formatUnit(seconds));
    }

    updateTimer();
    window.setInterval(updateTimer, 1000);
  });
});

$(document).ready(function () {
  $("[data-four-steps-slider]").each(function () {
    var $section = $(this);
    var $track = $section.find(".four-steps-slider__track");
    var $previous = $section.find(".four-steps-slider__arrow--prev");
    var $next = $section.find(".four-steps-slider__arrow--next");
    var resizeDebounce;
    var isSyncingHeights = false;

    function resetFourStepsSlideStyles() {
      if (isSyncingHeights) {
        return;
      }

      var $slides = $track.find(".four-steps-slider-item");

      if (!$slides.length) {
        return;
      }

      // Let CSS control slide height — inline values break tablet/desktop layouts.
      $slides.css("height", "");

      if ($track.hasClass("slick-initialized")) {
        isSyncingHeights = true;
        $track.slick("setPosition");
        isSyncingHeights = false;
      }
    }

    if (!$track.length || $track.hasClass("slick-initialized") || $track.children().length < 2) {
      return;
    }

    $track.on("init reInit breakpoint", function () {
      window.setTimeout(resetFourStepsSlideStyles, 0);
    });

    $track.slick({
      autoplay: false,
      arrows: true,
      dots: false,
      infinite: false,
      variableWidth: true,
      centerMode: true,
      centerPadding: "0px",
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      waitForAnimate: true,
      speed: 400,
      cssEase: "ease-out",
      touchThreshold: 8,
      prevArrow: $previous,
      nextArrow: $next,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            variableWidth: false,
            centerMode: false
          }
        }
      ]
    });

    $previous.add($next).on("click", function () {
      var $btn = $(this);

      this.blur();
      $btn.addClass("is-just-clicked");
      $btn.one("pointerleave mouseleave", function () {
        $btn.removeClass("is-just-clicked");
      });
    });

    $(window).on("resize", function () {
      clearTimeout(resizeDebounce);
      resizeDebounce = setTimeout(resetFourStepsSlideStyles, 120);
    });
  });

  $("[data-faq-section]").each(function () {
    var $section = $(this);
    var $items = $section.find(".faq-section-item");

    $section.on("click", ".faq-section-item__trigger", function () {
      var $item = $(this).closest(".faq-section-item");
      var $panel = $item.find(".faq-section-item__panel");
      var isOpen = $item.hasClass("is-open");

      $items.not($item).removeClass("is-open")
        .find(".faq-section-item__trigger").attr("aria-expanded", "false");
      $items.not($item).find(".faq-section-item__panel").attr("aria-hidden", "true");

      if (isOpen) {
        $item.removeClass("is-open");
        $(this).attr("aria-expanded", "false");
        $panel.attr("aria-hidden", "true");
      } else {
        $item.addClass("is-open");
        $(this).attr("aria-expanded", "true");
        $panel.attr("aria-hidden", "false");
      }
    });
  });

  $("[data-drag-scroll]").each(function () {
    var gallery = this;
    var isDragging = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;

    $(gallery).on("mousedown", function (e) {
      if (e.button !== 0) {
        return;
      }

      if ($(e.target).closest(".video-opinions-card").length) {
        return;
      }

      isDragging = true;
      moved = false;
      startX = e.pageX;
      scrollLeft = gallery.scrollLeft;
      gallery.classList.add("is-dragging");
    });

    $(window).on("mousemove.dragScroll", function (e) {
      if (!isDragging) {
        return;
      }

      e.preventDefault();
      var walk = e.pageX - startX;

      if (Math.abs(walk) > 3) {
        moved = true;
      }

      gallery.scrollLeft = scrollLeft - walk;
    });

    $(window).on("mouseup.dragScroll", function () {
      if (!isDragging) {
        return;
      }

      isDragging = false;
      gallery.classList.remove("is-dragging");
    });

    $(gallery).on("click", "a, button", function (e) {
      if ($(this).hasClass("video-opinions-card")) {
        return;
      }

      if (moved) {
        e.preventDefault();
        moved = false;
      }
    });
  });
});

$(document).ready(function () {
  $("[data-catering-map-delivery]").each(function () {
    var $delivery = $(this);
    var $form = $delivery.find("[data-catering-map-form]");
    var $town = $delivery.find("[data-catering-map-town]");
    var $postal = $delivery.find("[data-catering-map-postal]");
    var locationsRaw = $delivery.attr("data-delivery-locations");

    if (!$form.length || !$town.length || !$postal.length || !locationsRaw) {
      return;
    }

    var locations = [];

    try {
      locations = JSON.parse(locationsRaw);
    } catch (error) {
      return;
    }

    function normalizePostalCode(value) {
      return String(value || "").replace(/[\s-]/g, "");
    }

    function normalizeTown(value) {
      return String(value || "").trim().replace(/\s+/g, " ").toLocaleLowerCase("pl");
    }

    // Oba pola są wymagane. Kod pocztowy może obejmować kilka miejscowości,
    // więc dostawa jest dostępna tylko dla zgodnej pary.
    function isPairAllowed(townValue, postalValue) {
      var town = normalizeTown(townValue);
      var code = normalizePostalCode(postalValue);

      if (!town || !code) {
        return false;
      }

      return locations.some(function (location) {
        return normalizeTown(location && location.town) === town
          && normalizePostalCode(location && location.zip) === code;
      });
    }

    function setInputsDisabled(disabled) {
      $town.prop("disabled", disabled);
      $postal.prop("disabled", disabled);
    }

    function resetDeliveryCheck() {
      $delivery.removeClass("is-success is-error");
      $town.removeClass("is-invalid").val("");
      $postal.removeClass("is-invalid").val("");
      setInputsDisabled(false);
    }

    $form.on("submit", function (event) {
      event.preventDefault();

      if ($delivery.hasClass("is-success") || $delivery.hasClass("is-error")) {
        return;
      }

      var town = normalizeTown($town.val());
      var code = normalizePostalCode($postal.val());

      $town.toggleClass("is-invalid", !town);
      $postal.toggleClass("is-invalid", !code);

      if (!town || !code) {
        return;
      }

      if (isPairAllowed($town.val(), $postal.val())) {
        $delivery.removeClass("is-error").addClass("is-success");
        setInputsDisabled(true);
        return;
      }

      $delivery.removeClass("is-success").addClass("is-error");
      setInputsDisabled(true);
    });

    $delivery.find("[data-catering-map-reset]").on("click", function () {
      resetDeliveryCheck();
    });
  });
});
